import React, { useContext } from "react";
import ThemeContext from "../contexts/ThemeContext";

const ProductForm = ({
  editingProduct,
  form,
  handleChange,
  handleImageChange,
  handleSubmit,
  image,
  setEditingProduct,
  setForm,
  setImage,
}) => {
  const { isDark } = useContext(ThemeContext);

  return (
    <div
      className={`card shadow-sm p-4 mb-4 ${isDark ? 'border-secondary' : ''}`}
      style={isDark ? { backgroundColor: '#1e1e1e', borderColor: '#444' } : {}}
    >
      <h2 className={`h5 mb-3 ${isDark ? 'text-light' : ''}`}>
        {editingProduct ? "Edit Product" : "Add Product"}
      </h2>

      <form className="row g-3" onSubmit={handleSubmit}>
        {["name", "category", "pack", "originalPrice", "offerPrice"].map(
          (field) => (
            <div className="col-12 col-md-6" key={field}>
              <label className={`form-label text-capitalize ${isDark ? 'text-light' : ''}`}>
                {field}
              </label>

              <input
                name={field}
                value={form[field]}
                onChange={handleChange}
                className={`form-control ${isDark ? 'bg-dark text-light border-secondary dark-input' : ''}`}
                required
              />
            </div>
          )
        )}

        <div className="col-12 col-md-6">
          <label className={`form-label ${isDark ? 'text-light' : ''}`}>Product Image</label>
          <input
            type="file"
            accept="image/*"
            className={`form-control ${isDark ? 'bg-dark text-light border-secondary' : ''}`}
            onChange={handleImageChange}
            required={!editingProduct}
          />
        </div>

        <div className="col-12">
          <button className="btn btn-danger me-2">
            {editingProduct ? "Update Product" : "Add Product"}
          </button>

          {editingProduct && (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                setEditingProduct(null);
                setForm({
                  name: "",
                  category: "",
                  pack: "",
                  originalPrice: "",
                  offerPrice: "",
                });
                setImage(null);
              }}

            >
              Cancel
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default ProductForm;